import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import type { RetainedBeaconChoice, RetainedBeaconEligibility } from '@/hooks/useRetainedBeaconDischarge';
import {
  RETAINED_BEACON_DISCHARGE_COPY,
  RetainedBeaconDischargeActions,
  RetainedBeaconDischargeChoice,
} from './RetainedBeaconDischargeChoice';

interface Props {
  open: boolean;
  eligibility?: RetainedBeaconEligibility | null;
  onChoose: (choice: RetainedBeaconChoice) => void | Promise<void>;
  onCancel: () => void;
  working?: boolean;
  errorMessage?: string | null;
}

export function RetainedBeaconChoiceDialog({
  open,
  eligibility,
  onChoose,
  onCancel,
  working = false,
  errorMessage,
}: Props) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth aria-labelledby="retained-beacon-choice-title">
      <DialogTitle id="retained-beacon-choice-title">{RETAINED_BEACON_DISCHARGE_COPY.title}</DialogTitle>
      <DialogContent>
        <RetainedBeaconDischargeChoice eligibility={eligibility} />
        {errorMessage && <DialogContentText color="error">{errorMessage}</DialogContentText>}
      </DialogContent>
      <DialogActions style={{ flexWrap: 'wrap', gap: 8, padding: '16px 24px' }}>
        <RetainedBeaconDischargeActions onChoose={onChoose} onCancel={onCancel} working={working} />
      </DialogActions>
    </Dialog>
  );
}
